let APIURI ="https://zomato-cq2n.onrender.com";

module.exports =  APIURI ;

